import React from 'react';
import Pattren from '../../../Assets/images/Pattrens/footer.webp';

const CustomizedQuote = () => {
    return (
        <section className='aug-perfec-solution'>
            <div className='container'>
                <div className='aug-perfec-solution-wrap'>
                    <div className='row align-items-center'>
                        <div className='col-lg-5 col-md-12 col-12'>
                            <div className='aug-perfec-solution-box'>
                                <h2 className='mb-3'>The Optimal AI for Clinicians</h2>
                                <p>Our team would be delighted to provide assistance on any additional queries. <a href="mailto: sales@augnito.ai">  sales@augnito.ai </a></p>
                            </div>
                        </div>
                        <div className='offset-lg-3 col-lg-4 col-md-12 col-12'>
                            <div className='aug-perfec-solution__img'>
                                <img src={Pattren} alt="pattern" className="img-fluid"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CustomizedQuote;